/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconFlameSymbol: {
  name: 'flame_symbol';
  data: string;
} = {
  name: 'flame_symbol',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M225.295-309.063c0 57.375 47.702 66.938 47.702 114.75 0 19.125-15.901 47.812-39.751 47.812s-39.751-28.688-23.851-76.5c-23.851 19.125-31.801 38.25-31.801 57.375 0 47.813 39.751 95.625 95.403 95.625S368.4-98.688 368.4-156.064c.355-84.867-81.303-113.217-103.354-153-15.901-28.688-7.95-47.813 7.95-66.938-31.8 9.564-47.701 36.339-47.701 66.939z" transform="matrix(2.25523 0 0 1.875 -309.672 724.118)"/></svg>`,
};
